import React from 'react';
import '../template-file-css/document-file-template.css';


export const ACTS_FinancialResponsibilityAgreementAuthorization = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='ACTS_FinancialResponsibilityAgreementAuthorization' className='file-pdf-document'>
            <div className='file-template'>

                <h3>FINANCIAL RESPONSIBILITY AGREEMENT AND AUTHORIZATION
                </h3><h4>INDIVIDUAL'S FINANCIAL RESPONSIBILITY
                </h4>
                <ul>
                    <li>I understand that I am financially responsible for my health insurance deductible, coinsurance or non-covered service.
                    </li>
                    <li>Co-payments are due at time of service.
                    </li>
                    <li>In the event that my health plan determines a service to be "not payable", I will be responsible for the
                        complete charge and agree to pay the costs of all services provided.
                    </li>
                    <li>If I am uninsured, I agree to pay for the services rendered to me at time of service.
                    </li>
                </ul>
                <p className='w-750'>
                    My co-pay/co-insurance, based on the information I have provided to Amethyst Consulting & Treatment Solutions,
                    PLLC, will be $<input type="text" id="txtCopay" name="txtCopay" className='add-only w-100 custom-add-only' /> / <input type="text" id="txtCopay_1" name="txtCopay_1" className='add-only w-100 custom-add-only' />% per visit.
                </p>
                <p className='w-750'>
                    My current payor is:
                    <input type="text" id="txtCurrentPayor" name="txtCurrentPayor" className='add-only w-100 custom-add-only' />
                    My policy number is:
                    <input type="text" id="txtPolicyNumb" name="txtPolicyNumb" className='add-only w-100 custom-add-only' />
                </p>
                <p className='w-750'>
                    My current deductible is $ <input type="text" id="txtCurrentDeduct" name="txtCurrentDeduct" className='add-only w-100 custom-add-only' /> and $ <input type="text" id="txtCurrentDeduct_1" name="txtCurrentDeduct_1" className='add-only w-100 custom-add-only' /> is remaining as of today
                </p>
                <p className='w-750'>
                    My current out of pocket maximum is $<input type="text" id="txtCurrentPocket" name="txtCurrentPocket" className='add-only w-100 custom-add-only' /> and $ <input type="text" id="txtCurrentPocket_1" name="txtCurrentPocket_1" className='add-only w-100 custom-add-only' /> is remaining as of today.
                </p>
                <h4>INSURANCE AUTHORIZATION FOR ASSIGNMENT OF BENEFITS
                </h4>
                <p className='w-750'>
                    I hereby authorize and direct payment of my medical benefits to Amethyst Consulting & Treatment Solutions, PLLC
                    on my behalf for any services furnished to me by the providers.
                </p>
                <h4>AUTHORIZATION TO RELEASE RECORDS
                </h4>
                <p className='w-750'>
                    I hereby authorize Amethyst Consulting & Treatment Solutions, PLLC to release to my insurer, governmental
                    agencies, or any other entity financially responsible for my medical care, all information, including diagnosis and
                    the records of any treatment or examination rendered to me needed to substantiate payment for such services as
                    well as information required for precertification, authorization or referral to other provider.
                </p>
                <p className='w-750'>
                    The above information is true to the best of my knowledge. I authorize Amethyst to bill my insurance company and the benefits for
                    the services provided by Amethyst are paid directly to Amethyst. I understand that I am financially responsible for any balance. I
                    also authorize Amethyst Consulting & Treatment Solutions or the insurance company to release any information required to process
                    my claims.
                </p>
                <table>
                    <tr>
                        <td className='signature w-500'>&nbsp;
                        </td>
                        <td className='signature w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-500">Client/Responsible Party Signature:
                        </td>
                        <td className="small w-250">Date:
                        </td>
                    </tr>
                    <tr>
                        <td className='signature w-500'>&nbsp;
                        </td>
                        <td className='signature w-250'>&nbsp;
                        </td>
                    </tr>
                    <tr>
                        <td className="small w-500">Amethyst Representative Signature:
                        </td>
                        <td className="small w-250">Date:
                        </td>
                    </tr>
                </table>


            </div>
        </form>

    )
}  
